var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { fill: "currentColor" },
      attrs: {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.0625 8.8125C13.0625 8.39829 13.3983 8.0625 13.8125 8.0625H26.3125C26.7267 8.0625 27.0625 8.39829 27.0625 8.8125V11.8125H35.0625C35.4767 11.8125 35.8125 12.1483 35.8125 12.5625V27.5625C35.8125 27.9767 35.4767 28.3125 35.0625 28.3125H33.3125V34.4375C33.3125 34.8517 32.9767 35.1875 32.5625 35.1875H7.5625C7.14829 35.1875 6.8125 34.8517 6.8125 34.4375V28.3125H5.0625C4.64829 28.3125 4.3125 27.9767 4.3125 27.5625V12.5625C4.3125 12.1483 4.64829 11.8125 5.0625 11.8125H13.0625V8.8125ZM14.5625 11.8125H25.5625V9.5625H14.5625V11.8125ZM8.3125 28.3125V33.6875H31.8125V28.3125H25.1875V30.0625C25.1875 30.4767 24.8517 30.8125 24.4375 30.8125H15.0625C14.6483 30.8125 14.3125 30.4767 14.3125 30.0625V28.3125H8.3125ZM14.3125 26.8125V25.0625C14.3125 24.6483 14.6483 24.3125 15.0625 24.3125H24.4375C24.8517 24.3125 25.1875 24.6483 25.1875 25.0625V26.8125H34.3125V13.3125H5.8125V26.8125H14.3125ZM15.8125 25.8125V29.3125H23.6875V25.8125H15.8125Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }